import React from 'react'
import Dashnav from '../Components/Dashnav'
import Leftmenu from '../Components/Leftmenu'
import JobBoardComp from './JobBoardComp'


function JobBoard() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <JobBoardComp/>
            </div>
        </div>  
    </div>
  )
}

export default JobBoard